<template>
  <v-dialog v-model="show" width="50vw" scrollable persistent>
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2">
        Información de análisis
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="folioSelected"
                :items="folios"
                dense
                :loading="isLoadingFolios"
                outlined
                clearable
                return-object
                item-text="folio"
                prepend-inner-icon="mdi-file-search-outline"
                no-data-text="Sin folios"
                label="Selecciona folio resultados"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <div v-if="folioSelected">
            <v-row v-if="!fecthingAnalysis">
              <v-col>
                <v-expansion-panels>
                  <v-expansion-panel
                    v-for="sample in measurementData.samples"
                    :key="sample._id"
                  >
                    <v-expansion-panel-header>
                      <div class="subtitle-1 font-weight-bold">
                        Muestra: {{ sample.folioAnalysis }} -
                        {{ sample.soilArea.name }}
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card outlined class="mb-4">
                        <!-- Beneficial Microorganisms -->
                        <v-card-text>
                          <h3 class="subtitle-1 font-weight-bold">Benéficos</h3>
                          <v-simple-table dense>
                            <thead>
                              <tr>
                                <th>ID</th>
                                <th>Marcador molecular</th>
                                <th>UMC</th>
                                <th>Nivel de benéficos</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="mo in getBeneficials(sample)"
                                :key="mo._id"
                              >
                                <td>
                                  <span class="primary--text">
                                    {{ mo.molecularMarkerID }}
                                  </span>
                                </td>
                                <td>
                                  <span class="font-italic">
                                    {{ mo.identification }}
                                  </span>
                                </td>
                                <td>
                                  <div v-if="mo.molecularPresence">
                                    {{ mo.umc }}
                                  </div>
                                  <div v-else>N/D</div>
                                </td>
                                <td>
                                  <div
                                    class="bar-container"
                                    v-if="mo.level === 'high'"
                                  >
                                    <div
                                      class="bar-segment"
                                      :style="`width: 33.33%;
                                    background-color: ${
                                      mo.molecularPresence
                                        ? '#65ac1e'
                                        : '#e0e0e0'
                                    } ;`"
                                    ></div>
                                    <div
                                      class="bar-segment"
                                      :style="`width: 33.33%;
                                    background-color: ${
                                      mo.molecularPresence
                                        ? '#65ac1e'
                                        : '#e0e0e0'
                                    } ;`"
                                    ></div>
                                    <div
                                      class="bar-segment"
                                      :style="`width: 33.33%;
                                    background-color: ${
                                      mo.molecularPresence
                                        ? '#65ac1e'
                                        : '#e0e0e0'
                                    } ;`"
                                    ></div>
                                  </div>

                                  <div
                                    class="bar-container"
                                    v-if="mo.level === 'medium'"
                                  >
                                    <div
                                      class="bar-segment"
                                      :style="`width: 33.33%;
                                    background-color: ${
                                      mo.molecularPresence
                                        ? '#94cf0c'
                                        : '#e0e0e0'
                                    };`"
                                    ></div>
                                    <div
                                      class="bar-segment"
                                      :style="`width: 33.33%;
                                    background-color: ${
                                      mo.molecularPresence
                                        ? '#94cf0c'
                                        : '#e0e0e0'
                                    };`"
                                    ></div>
                                    <div
                                      class="bar-segment"
                                      style="
                                        width: 33.34%;
                                        background-color: #e0e0e0;
                                      "
                                    ></div>
                                  </div>

                                  <div
                                    class="bar-container"
                                    v-if="mo.level === 'low'"
                                  >
                                    <div
                                      class="bar-segment"
                                      :style="`width: 33.33%;
                                    background-color: ${
                                      mo.molecularPresence
                                        ? '#f7e211'
                                        : '#e0e0e0'
                                    };`"
                                    ></div>
                                    <div
                                      class="bar-segment"
                                      style="
                                        width: 33.33%;
                                        background-color: #e0e0e0;
                                      "
                                    ></div>
                                    <div
                                      class="bar-segment"
                                      style="
                                        width: 33.34%;
                                        background-color: #e0e0e0;
                                      "
                                    ></div>
                                  </div>

                                  <div v-if="mo.mediumRange">
                                    <v-row>
                                      <v-col>
                                        <span v-if="mo.level === 'high'">
                                          Alto
                                        </span>
                                        <span v-else-if="mo.level === 'medium'"
                                          >Medio
                                        </span>
                                        <span v-else-if="mo.level === 'low'">
                                          Bajo
                                        </span>
                                      </v-col>
                                      <v-col>
                                        &lt; {{ mo.mediumRange.min }}
                                      </v-col>
                                      <v-col>
                                        &gt; {{ mo.mediumRange.max }}
                                      </v-col>
                                    </v-row>
                                  </div>
                                </td>
                              </tr>
                              <tr v-if="getBeneficials(sample).length === 0">
                                <td colspan="4" class="text-center">
                                  No se detectaron microorganismos benéficos
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </v-card-text>

                        <v-divider></v-divider>

                        <!-- Pathogens -->
                        <v-card-text>
                          <h3 class="subtitle-1 font-weight-bold">
                            Alerta de patógeno
                          </h3>
                          <v-simple-table dense>
                            <thead>
                              <tr>
                                <th>ID</th>
                                <th>Marcador molecular</th>
                                <th>UMC</th>
                                <th>Nivel de riesgo</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="mo in getPathogens(sample)"
                                :key="mo._id"
                              >
                                <td>
                                  <span class="orange--text">
                                    {{ mo.molecularMarkerID }}
                                  </span>
                                </td>
                                <td>
                                  <span class="font-italic">
                                    {{ mo.identification }}
                                  </span>
                                </td>
                                <td>
                                  <div v-if="mo.molecularPresence">
                                    {{ mo.umc }}
                                  </div>
                                  <div v-else>N/D</div>
                                </td>
                                <td>
                                  <div
                                    class="bar-container"
                                    v-if="mo.level === 'high'"
                                  >
                                    <div
                                      class="bar-segment"
                                      :style="`width: 33.33%;
                                    background-color: ${
                                      mo.molecularPresence
                                        ? '#db5f07'
                                        : '#e0e0e0'
                                    } ;`"
                                    ></div>
                                    <div
                                      class="bar-segment"
                                      :style="`width: 33.33%;
                                    background-color: ${
                                      mo.molecularPresence
                                        ? '#db5f07'
                                        : '#e0e0e0'
                                    } ;`"
                                    ></div>
                                    <div
                                      class="bar-segment"
                                      :style="`width: 33.33%;
                                    background-color: ${
                                      mo.molecularPresence
                                        ? '#db5f07'
                                        : '#e0e0e0'
                                    } ;`"
                                    ></div>
                                  </div>

                                  <div
                                    class="bar-container"
                                    v-if="mo.level === 'medium'"
                                  >
                                    <div
                                      class="bar-segment"
                                      :style="`width: 33.33%;
                                    background-color: ${
                                      mo.molecularPresence
                                        ? '#f79711'
                                        : '#e0e0e0'
                                    };`"
                                    ></div>
                                    <div
                                      class="bar-segment"
                                      :style="`width: 33.33%;
                                    background-color: ${
                                      mo.molecularPresence
                                        ? '#f79711'
                                        : '#e0e0e0'
                                    };`"
                                    ></div>
                                    <div
                                      class="bar-segment"
                                      style="
                                        width: 33.34%;
                                        background-color: #e0e0e0;
                                      "
                                    ></div>
                                  </div>

                                  <div
                                    class="bar-container"
                                    v-if="mo.level === 'low'"
                                  >
                                    <div
                                      class="bar-segment"
                                      :style="`width: 33.33%;
                                    background-color: ${
                                      mo.molecularPresence
                                        ? '#f7e211'
                                        : '#e0e0e0'
                                    };`"
                                    ></div>
                                    <div
                                      class="bar-segment"
                                      style="
                                        width: 33.33%;
                                        background-color: #e0e0e0;
                                      "
                                    ></div>
                                    <div
                                      class="bar-segment"
                                      style="
                                        width: 33.34%;
                                        background-color: #e0e0e0;
                                      "
                                    ></div>
                                  </div>
                                  <div v-if="mo.mediumRange">
                                    <v-row>
                                      <v-col>
                                        <span v-if="mo.level === 'high'">
                                          Alto
                                        </span>
                                        <span v-else-if="mo.level === 'medium'">
                                          Medio
                                        </span>
                                        <span v-else-if="mo.level === 'low'">
                                          Bajo
                                        </span>
                                      </v-col>
                                      <v-col>
                                        &lt; {{ mo.mediumRange.min }}
                                      </v-col>
                                      <v-col>
                                        &gt; {{ mo.mediumRange.max }}
                                      </v-col>
                                    </v-row>
                                  </div>
                                </td>
                              </tr>
                              <tr v-if="getPathogens(sample).length === 0">
                                <td colspan="4" class="text-center">
                                  No se detectaron patógenos
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

                <!-- Implementation ends here -->
              </v-col>
            </v-row>
            <v-row no-gutters v-else>
              <v-col cols="12">
                <v-skeleton-loader
                  type="list-item-three-line"
                ></v-skeleton-loader>
              </v-col>
              <v-col cols="12">
                <v-skeleton-loader
                  type="list-item-three-line"
                ></v-skeleton-loader>
              </v-col>
              <v-col cols="12">
                <v-skeleton-loader
                  type="list-item-three-line"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn color="gray" block @click="closeModal" dark>Cerrar</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
    <SubSamplePhoto
      :img="img"
      :visible="showImageDialog"
      @hideSubSampleModal="hideSubSampleModal"
    />
  </v-dialog>
</template>

<script>
//vuex
import { mapState, mapActions, mapMutations } from "vuex";
//components
import SubSamplePhoto from "@/components/station1/modals/SubSamplePhoto";

export default {
  components: {
    SubSamplePhoto,
  },
  data: () => ({
    loader: false,
    isLoadingFolios: false,
    folioSelected: null,
    folios: [],
    fecthingAnalysis: false,
    confrontations: [],
    nematodes: [],
    nutritions: null,
    img: [],
    showImageDialog: false,
    measurementData: {
      samples: [],
    },
  }),
  props: {
    value: Boolean,
    profitId: {
      type: String,
      required: true,
    },
    code: String,
  },
  async mounted() {
    await this.fecthFolios();
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapActions("profit", [
      "getFoliosInProfit",
      "getValuationFromAnalysis",
      "getMeasureFromAnalysis",
    ]),
    closeModal() {
      this.show = false;
    },
    async fecthFolios() {
      this.isLoadingFolios = true;
      try {
        let payload = {
          profitId: this.profitId,
          code: this.code,
        };
        let response = await this.getFoliosInProfit(payload);
        if (!response) throw response;
        this.folios = response.folios;
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al cargar los folios",
          timeout: 5000,
        });
      }
      this.isLoadingFolios = false;
    },
    showImage(img) {
      this.img = [
        {
          title: "",
          src: img,
        },
      ];
      this.showImageDialog = true;
    },
    hideSubSampleModal(value) {
      this.showImageDialog = value;
    },
    getBeneficials(sample) {
      if (!sample.microorganism) return [];
      return sample.microorganism.filter(
        (mo) => !mo.possibleThreat && mo.type !== "Hongo"
      );
    },
    getPathogens(sample) {
      if (!sample.microorganism) return [];
      return sample.microorganism.filter(
        (mo) => mo.possibleThreat || mo.type === "Hongo"
      );
    },
  },
  watch: {
    async folioSelected(value) {
      if (!value) return;
      try {
        this.fecthingAnalysis = true;
        let payload = {
          analysisId: value._id,
        };
        let response = await this.getMeasureFromAnalysis(payload);
        if (!response) throw response;
        this.measurementData = response;
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al cargar analisis",
          timeout: 5000,
        });
      }
      this.fecthingAnalysis = false;
    },
  },
};
</script>

<style scoped>
/* Estilos CSS personalizados para el contenido del panel */
.custom-panel-content {
  max-height: 500px; /* Tamaño máximo del panel */
  overflow-y: auto; /* Habilitar el desplazamiento vertical (scroll) si el contenido excede el tamaño máximo */
}
.colored-box {
  display: flex;
  align-items: center; /* Para centrar verticalmente el span */
}

.colored-box span {
  flex: 1; /* Para que el span se expanda y ocupe todo el espacio disponible */
  display: inline-block;
  height: 20px;
}

/* Additional styling for the tables */
.v-data-table /deep/ th {
  font-weight: bold;
  background-color: #f5f5f5;
}

.bar-container {
  display: flex;
  height: 15px;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
}

.bar-segment {
  height: 100%;
  transition: background-color 0.3s ease;
}

.bar-segment:not(:last-child) {
  border-right: 1px solid white;
}
</style>